import React from "react";
import "./Company.scss";
import Header from "../common/Header/Header";
import Footer from '../common/Footer/NewFooter';
import LandingSection from "./CompanyLanding";
import NewsLatest from "../Home/NewsLatest";
import CFFriends from "./CFFriends";
import Hiring from "./Hiring";
import WorldClassTeam from "./WorldClassTeam";
import OurTeams from "./OurTeams";

const Company = () => {
  return (
    <div>
      <Header />
      <LandingSection />
      <NewsLatest />
      <OurTeams />
      {/* <WorldClassTeam />
      <CFFriends /> */}
      <Hiring />
      <Footer />
    </div>
  );
};

export default Company;
